export const categoryColours = [
  '#7359C5',
  '#9A87D6',
  '#4C65E1',
  '#7085F1',
  '#E56555',
  '#F48172',
  '#E7A948',
  '#EDBF78',
  '#63A2B6',
  '#81B7C8',
  '#48A77B',
  '#6CBE98',
  '#AB62B0',
  '#C384C7',
  '#DB578C',
  '#E77AA5',
  '#70A0B6',
  '#8EB4C7',
  '#60747D',
  '#92A3AA',
  '#5C4F95',
  '#7D71B3',
  '#97505E',
  '#AC6D78',
]

export const NO_CATEGORY_KEY = ''

export const normalizeCategoryKey = (category: string | null | undefined) => {
  return category?.trim() ? category.trim() : NO_CATEGORY_KEY
}

export const isNoCategory = (category: string) => category === NO_CATEGORY_KEY

export const DEFAULT_TREATMENT_COLOR = '#7359C5'
export const DEFAULT_MEMBER_COLOR = '#7359C5'

export const randomMemberColour = (usedColours: string[] = []) => {
  const used = new Set(usedColours.map(colour => colour.toUpperCase()))
  const unused = categoryColours.filter(colour => !used.has(colour.toUpperCase()))
  const pool = unused.length > 0 ? unused : categoryColours

  return pool[Math.floor(Math.random() * pool.length)]
}

export const DEFAULT_CATEGORIES_COLORS = [
  DEFAULT_TREATMENT_COLOR,
  '#4C65E1',
  '#E56555',
  '#E7A948',
  '#63A2B6',
  '#48A77B',
  '#AB62B0',
  '#DB578C',
]